(function() {
    'use strict';
    
a3_cabin_reports.factory('CabinReportSendToServerFactory', CabinReportSendToServerFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CabinReportSendToServerFactory
    * @description 
    *   Transform Cabin Reports in order to send them to the server
    * @ngInject
    */
function CabinReportSendToServerFactory() {

        /**
        * Initialize the CabinReportSendToServer
        * @memberof CabinReportSendToServerFactory
        */
		function CabinReportSendToServer() {
			this.Created = null;
			this.LastUpdated = null;
			this.FlightAimsId = null;
			this.FlightId = null;
			this.FlightDate = null;
			this.FlightNo = null;
			this.Departure = null;
			this.Arrival = null;
			this.ReportGuid = null;
			this.AuthorCrewId = null;
			this.AuthorCrewAimsId = null;

			this.ActualPassengerC = "";
			this.ActualPassengerY = "";

			this.CCMSCrewPositions = [];
			this.CrewRemarks = null;
            
			this.ItemsFoundDescription = null;
			this.ItemsFoundAgent = null;
			this.ItemsFoundSignature = null;
			this.UMNumber = 0;
			this.UMDescription = null;
			this.UMAgent = null;
			this.UMSignature = null;
			this.WaterUpliftSuggestedQuantity = null;
			this.WaterUpliftInitial = null;
			this.WaterUpliftRemarks = null;
			this.BarTrolleys = [];
			this.FirstAidKits = [];
			this.MedicalIncidents = [];
			this.SpecialMealIssues = [];
			this.Supplies = [];
			this.TravelValueSeals = [];
			this.LuggageNumber = 0;
			this.LuggageDescription = null;
			this.FoundProperties = [];

			this.TravelValueIncomplete = false;
			this.TravelValueIncompleteRow = null;
			this.TravelValueIncompleteReason = null;
			this.TravelValueRemarks = null;
			this.Remarks = null;
			this.VariousIssues = [];
			this.DepartureGroundServices = [];
			this.ArrivalGroundServices = [];
			this.UpgradedPassengers = [];
			this.ChangedSeats = [];
			//BoardingTimes
			this.BoardingTimesRemarks = null;
			this.FirstPaxTime = null;
			this.LastPaxTime = null;

			this.GroomingReports = [];
		}
    
        /**
        * Initialize the CabinReportSendToServerItem
        * @memberof CabinReportSendToServerFactory
        */
        function CabinReportSendToServerItem() {
			this.ReportGuid = null;
			this.TemplateItemId = null;
			this.Value = 0;
			this.Remarks = '';
			this.Photos = new Array();
		}
			
		var service = {
			getCompletedListFromCabinReportLocalEdits : getCompletedListFromCabinReportLocalEdits,
			getReportFromCabinReportLocalEdit : getReportFromCabinReportLocalEdit,
			stripIds : stripIds
		}

        /**
         * Transform all cabin local reports in order to be sent to the server
         * @memberof CabinReportSendToServerFactory
         * @param {Array} cabinReportLocalEdits
         * @returns {Array} CabinReportSendToServer 
         */
		function getCompletedListFromCabinReportLocalEdits(cabinReportLocalEdits) {
			var result = [];

			if (cabinReportLocalEdits == null)
				return result;

			var arrayLength = cabinReportLocalEdits.length;
			for (var i = 0; i < arrayLength; i++) {
				if (cabinReportLocalEdits[i].Status === 'completed') {
					result.push(getReportFromCabinReportLocalEdit(cabinReportLocalEdits[i]));
				}
			}

			//Temporary: fix: Ground Services:  Used values (true/false) from local storage.
		 	var resultChecked = fixUsedValueLS(result);

			//TODO: flight orders

			return resultChecked;
		}

		//Temporary: fix - Ground Services - local storage from true/false values. (int Used: 0:false, 1:true, 2:inop) 
		function fixUsedValueLS(cabinReportLocalEdits){
			for (var i = 0; i < cabinReportLocalEdits.length; i++) {
				if(cabinReportLocalEdits[i].DepartureGroundServices.length > 0){
					for(var j = 0; j < cabinReportLocalEdits[i].DepartureGroundServices.length; j++){
						if (cabinReportLocalEdits[i].DepartureGroundServices[j]){
							if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === true) {
								cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 1;
							}else if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === false){
								cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 0;
							}
						}
					}
				}
			}
			return cabinReportLocalEdits;
		}


         /**
         * Transform a cabin local reports in order to be sent to the server
         * @memberof CabinReportSendToServerFactory
         * @param {object} cabinReportLocalEdit
         * @returns {object} CabinReportSendToServer 
         */
		function getReportFromCabinReportLocalEdit(cabinReportLocalEdit) {
			var result = new CabinReportSendToServer();

			result.Created = cabinReportLocalEdit.Created;
			result.LastUpdated = cabinReportLocalEdit.LastUpdated;
			result.FlightAimsId = cabinReportLocalEdit.FlightAimsId;
			result.FlightId = cabinReportLocalEdit.FlightId;
			result.FlightDate = cabinReportLocalEdit.FlightDate;
			result.FlightNo = cabinReportLocalEdit.FlightNo;
			result.Departure = cabinReportLocalEdit.Departure;
			result.Arrival = cabinReportLocalEdit.Arrival;
			result.ReportGuid = cabinReportLocalEdit.ReportGuid;
			result.AuthorCrewId = cabinReportLocalEdit.AuthorId;
			result.AuthorCrewAimsId = cabinReportLocalEdit.AuthorAimsId;

			result.ActualPassengerC = cabinReportLocalEdit.ActualPassengerC;
			result.ActualPassengerY = cabinReportLocalEdit.ActualPassengerY;

			result.CrewRemarks = cabinReportLocalEdit.CrewRemarks;

			result.ItemsFoundDescription = cabinReportLocalEdit.ItemsFoundDescription;
			result.ItemsFoundAgent = cabinReportLocalEdit.ItemsFoundAgent;
			result.ItemsFoundSignature = cabinReportLocalEdit.ItemsFoundSignature;

			result.UMNumber = cabinReportLocalEdit.UMNumber;
			result.UMDescription = cabinReportLocalEdit.UMDescription;
			result.UMAgent = cabinReportLocalEdit.UMAgent;
			result.UMSignature = cabinReportLocalEdit.UMSignature;

			result.LuggageNumber = cabinReportLocalEdit.LuggageNumber;
			result.LuggageDescription = cabinReportLocalEdit.LuggageDescription;

			result.WaterUpliftSuggestedQuantity = cabinReportLocalEdit.WaterUpliftSuggestedQuantity;
			result.WaterUpliftInitial = cabinReportLocalEdit.WaterUpliftInitial;
			result.WaterUpliftRemarks = cabinReportLocalEdit.WaterUpliftRemarks;

			result.CCMSCrewPositions =  stripIds(cabinReportLocalEdit.CCMSCrewPositions);
			result.BarTrolleys =  stripIds(cabinReportLocalEdit.BarTrolleys);
			result.FirstAidKits =  stripIds(cabinReportLocalEdit.FirstAidKits);
			result.MedicalIncidents =  stripIds(cabinReportLocalEdit.MedicalIncidents);
			result.SpecialMealIssues =  stripIds(cabinReportLocalEdit.SpecialMealIssues);
			result.Supplies =  stripIds(cabinReportLocalEdit.Supplies);
			result.TravelValueSeals =  stripIds(cabinReportLocalEdit.TravelValueSeals);

			result.TravelValueIncomplete = cabinReportLocalEdit.TravelValueIncomplete;
			result.TravelValueIncompleteRow = cabinReportLocalEdit.TravelValueIncompleteRow;
			result.TravelValueIncompleteReason = cabinReportLocalEdit.TravelValueIncompleteReason;
			result.TravelValueRemarks = cabinReportLocalEdit.TravelValueRemarks;
			result.Remarks = cabinReportLocalEdit.Remarks;
			result.ArrivalGroundServices = cabinReportLocalEdit.ArrivalGroundServices;
			result.DepartureGroundServices = cabinReportLocalEdit.DepartureGroundServices;
			result.UpgradedPassengers = cabinReportLocalEdit.UpgradedPassengers;
			result.ChangedSeats = cabinReportLocalEdit.ChangedSeats;
			result.IncompleteServices = cabinReportLocalEdit.IncompleteServices;
			result.BoardingTimesRemarks = cabinReportLocalEdit.BoardingTimesRemarks;
			result.DisembarkationTimeRemarks = cabinReportLocalEdit.DisembarkationTimesRemarks;

			result.FlightOrders = cabinReportLocalEdit.FlightOrders;

			if(cabinReportLocalEdit.FirstPaxTime){
				result.FirstPaxTime = cabinReportLocalEdit.FirstPaxTime;
			}
			if(cabinReportLocalEdit.LastPaxTime){
				result.LastPaxTime = cabinReportLocalEdit.LastPaxTime;
			}
			if(cabinReportLocalEdit.FirstPaxDisembarkationTime){
				result.FirstPaxDisembarkationTime = cabinReportLocalEdit.FirstPaxDisembarkationTime;
			}
			if(cabinReportLocalEdit.LastPaxDisembarkationTime){
				result.LastPaxDisembarkationTime = cabinReportLocalEdit.LastPaxDisembarkationTime;
			}

			result.VariousIssues = [];

			var itemCount = cabinReportLocalEdit.VariousIssues.length;
			for (var i = 0; i < itemCount; i++) {

				var newItem = new CabinReportSendToServerItem();
				newItem.ReportGuid = cabinReportLocalEdit.ReportGuid;
				newItem.TemplateItemId = cabinReportLocalEdit.VariousIssues[i].Id;
				newItem.Value = cabinReportLocalEdit.VariousIssues[i].ItemHasValue ? 1 : 0;
				if (newItem.Value == 1) {
					newItem.Remarks = cabinReportLocalEdit.VariousIssues[i].ItemValue;
					newItem.Photos = stripIds(cabinReportLocalEdit.VariousIssues[i].Photos);
				}
				result.VariousIssues.push(newItem);

			}

			result.GroomingReports = cabinReportLocalEdit.GroomingReports;

			result.FoundProperties =  stripIds(cabinReportLocalEdit.FoundProperties);
			
			return result;
		}

        /**
         * Strip Ids of selected input
         * @memberof CabinReportSendToServerFactory
         * @param {array} inputArray
         * @returns {object} stripedInputArray 
         */
		function stripIds(inputArray) {
			for (var i = 0; i < inputArray.length; i++) {
				delete inputArray[i].Id;
			}
			return inputArray;
		}

		return service;
	}

})();